class MadeChat {
  #isChatVisible = false;

  #hideInterval = null;

  #chatWidgetId = "tidio-chat";

  #containerSelector = ".js-made-chat-container";

  #buttonSelector = ".js-made-chat-text";

  #boundHandleDocumentClick = null;

  #boundOpenTidioChat = null;

  #boundHandleMinimize = null;

  #pollAttempts = 0;

  #maxPollAttempts = 60;

  constructor() {
    this.init();
  }

  init() {
    this.#boundOpenTidioChat = this.#openTidioChat.bind(this);
    this.#boundHandleDocumentClick = this.#handleDocumentClick.bind(this);
    this.#boundHandleMinimize = this.#handleMinimize.bind(this);

    this.#$chatButtons.forEach(button => {
      button.addEventListener("click", this.#boundOpenTidioChat);
    });

    this.#hideInterval = setInterval(() => {
      this.#pollAttempts += 1;

      if (window.tidioChatApi) {
        clearInterval(this.#hideInterval);
        this.#hideInterval = null;
        window.tidioChatApi.hide?.();
        this.#isChatVisible = false;

        window.tidioChatApi.on("close", this.#boundHandleMinimize);
      } else if (this.#pollAttempts >= this.#maxPollAttempts) {
        clearInterval(this.#hideInterval);
        this.#hideInterval = null;
      }
    }, 500);

    document.addEventListener("click", this.#boundHandleDocumentClick);
  }

  destroy() {
    if (this.#hideInterval) {
      clearInterval(this.#hideInterval);
      this.#hideInterval = null;
    }

    if (this.#boundHandleDocumentClick) {
      document.removeEventListener("click", this.#boundHandleDocumentClick);
      this.#boundHandleDocumentClick = null;
    }

    if (this.#boundOpenTidioChat) {
      this.#$chatButtons.forEach(button => {
        button.removeEventListener("click", this.#boundOpenTidioChat);
      });
      this.#boundOpenTidioChat = null;
    }

    if (this.#boundHandleMinimize && window.tidioChatApi) {
      window.tidioChatApi.off?.("close", this.#boundHandleMinimize);
      this.#boundHandleMinimize = null;
    }
  }

  get #$chatButtons() {
    return document.querySelectorAll(this.#buttonSelector);
  }

  get #$chatWidget() {
    return document.getElementById(this.#chatWidgetId);
  }

  #handleMinimize() {
    this.#isChatVisible = false;
    window.tidioChatApi?.hide?.();
  }

  #openTidioChat(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.#$chatWidget && window.tidioChatApi) {
      this.#isChatVisible = true;
      setTimeout(() => {
        window.tidioChatApi?.show?.();
        window.tidioChatApi?.open?.();
      }, 100);
    }
  }

  #handleDocumentClick(event) {
    if (!this.#$chatWidget || !this.#isChatVisible) {
      return;
    }

    const $target = event.target;
    const $targetElement = $target.nodeType === Node.TEXT_NODE ? $target.parentElement : $target;

    const isClickOnWidget = MadeChat.#isClickOnElement(
      $targetElement,
      this.#$chatWidget,
      this.#chatWidgetId
    );

    let isClickOnContainer = false;
    const containers = document.querySelectorAll(this.#containerSelector);
    for (const container of containers) {
      if (MadeChat.#isClickOnElement($targetElement, container, this.#containerSelector)) {
        isClickOnContainer = true;
        break;
      }
    }

    if (!isClickOnWidget && !isClickOnContainer) {
      window.tidioChatApi?.hide?.();
      this.#isChatVisible = false;
    }
  }

  static #isClickOnElement($target, $element, selector) {
    if (!$element) return false;

    return (
      $target === $element ||
      $element.contains($target) ||
      ($target?.closest && $target.closest(selector) === $element)
    );
  }
}

const initMadeChat = onCreated => {
  const $chatButton = document.querySelector(".js-made-chat-text");
  if ($chatButton) {
    const chat = new MadeChat();
    onCreated?.(chat);
    return chat;
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        const $chatButtonAfterLoad = document.querySelector(".js-made-chat-text");
        if ($chatButtonAfterLoad) {
          onCreated?.(new MadeChat());
        }
      },
      { once: true }
    );
  }

  return null;
};

export default initMadeChat;
export { MadeChat };
